import React from 'react';
import styled from 'styled-components/macro';
import { useTranslate } from '../contexts/languageContext';
import NavMenu from '../components/NavMenu';
import { getIdHistorico } from '../utils';
import Descarga from '../components/svg/Descarga';
import Breadcrumbs from '../components/Breadcrumbs';
import { Link } from 'react-router-dom';
import { getUrl, getParents } from '../utils';
import Tooltip from '../components/Tooltip';
import DropdownHistorico from './DropdownHistorico';
import { getDataUrl } from '../router/Enrutador/utils';
import { FiChevronRight } from 'react-icons/fi';
import {ReactComponent as IconReset} from '../assets/img/IconReset.svg'
import { useIsMobile, useIsDesktop, useIsTablet } from '../hooks/useMediaQuery';
import Buscador from '../components/Buscador';
import BuscadorMobile from '../components/BuscadorMobile';
import { useParentLevel, useMesa } from '../contexts/pageContext';

/**
 * Componente situado debajo del header que nos muestra información relevante en
 * cada página, como un menú de navegación por ámbitos o la hora del envío
 */

const SCajaDescargas = styled.div`
  flex: 0 0 auto;
  width: 60px;
  height: 100%;
  //background-color: ${props => props.theme.colorHover || ''};
  align-self: end;
  @media print {
    display: none;
    }
`;

const SCajaEnvioYDescargas = styled.div`
  min-width:20%;
`;

const SLowerBanner = styled.div`
  width: 100%;
  height: 44px;
  background-color: transparent;
  display: flex;
  align-items: center;
  margin-top: 0px;
  border-right: 1px solid #00F7F0;
  color: #FFF;
  @media print {
    color: #1c4183;
    margin-top: 30px;
  }
`;

const SNavMenu = styled(NavMenu)`
  flex: 0 0 auto;
  vertical-align: middle;
  color: #1C4183;
  
`;

const LowerBanner = ({
  nomenclator,
  eleccion,
  ambito,
  page,
  variant,
  esHistorico,
  data,
  parentLevel,
}) => {
  const mesa = useMesa();
  const t = useTranslate();
  const isMobile = useIsMobile();
  const isDesktop = useIsDesktop();
  const esBoletin = data.tope === '1';
  return (
    <SLowerBanner>
      <StyledRoutedBreadcrumbs
        eleccion={eleccion}
        ambito={ambito}
        nomenclator={nomenclator}
        page={page}
        esHistorico={esHistorico}
        parentLevel={parentLevel}
      />
      {variant !== 'inicio' && (
        <>          
          <SCajaEnvioYDescargas>
            {esHistorico ? (
              <span
                css="font-weight: bold;
                   text-transform: uppercase;
                   padding: 20px;
                   box-sizing: border-box;
                   display: flex;
                   align-items: center;
                   justify-content: space-between;
                   max-width: 200px;
                   "
              >{`${esBoletin ? t('boletin') : t('avance')} ${
                data.numact
              }`}</span>
            ) : (
              <DropdownHistorico
                data={data}
                items={data.historico}
                id={ambito.i}
                eleccion={eleccion}
                nomenclator={nomenclator}
                page={page}
                tope={data.tope}
                parentLevel={parentLevel}
              />
            )}
          </SCajaEnvioYDescargas>
        </>
      )}
      { !esHistorico && (!isDesktop ? (
        <SBuscadorMobile
          nomenclator={nomenclator}
          eleccion={eleccion}
          ambito={ambito}
          page={page}
        />
      ) : (
        <SBuscador
          items={nomenclator.ambitos[eleccion]}
          eleccion={eleccion}
          nomenclator={nomenclator}
          page={page}
          searchIconColor="#FFF"
        />
      ))}
    </SLowerBanner>
  );
};

export default LowerBanner;

const RoutedBreadcrumbs = ({
  eleccion,
  ambito,
  nomenclator,
  className,
  page,
  esHistorico,
  parentLevel,
}) => {
  const mesa = useMesa();
  const parents = getParents(
    ambito.i,
    eleccion,
    nomenclator,
    parentLevel
  ).reverse();
  const ids = [...parents, ambito.i].slice(-2);
  let routes = ids.map(id => ({
    url: getUrl({ id, eleccion, nomenclator, page, parentLevel }),
    n: nomenclator.ambitos[eleccion][id].n,
  }));
  if (mesa) {
    routes = [
      routes[1],
      {
        url: getUrl({
          id: mesa,
          eleccion,
          nomenclator,
          page,
          parentLevel,
          mesa,
        }),
        n: `MESA ${Number(mesa.slice(1, 7))}`,
      },
    ];
  }
  return (
    <Breadcrumbs
      aria-label="migas"
      separator={<FiChevronRight />}
      className={className}
      esHistorico={esHistorico}
    >
      {routes.map(({ url, n }, index) => {
        const last = index === routes.length - 1;
        return (
          <div className="texto" key={url}>
            {esHistorico ? (
              <span
                className={last ? 'last' : 'first-historico'}
                data-testid={last ? 'last-breadcrumb' : undefined}
              >
               {n}
              </span>
            ) : last ? (
              <h2 data-testid="last-breadcrumb">
                <SNavMenu
                  nomenclator={nomenclator}
                  eleccion={eleccion}
                  ambito={ambito}
                  page={page}
                  parentLevel={parentLevel}
                >
                  {n}
                </SNavMenu>
              </h2>
            ) : (
              <Link className="first" to={url}>
                <IconReset/>
              </Link>
            )}
          </div>
        );
      })}
    </Breadcrumbs>
  );
};

const StyledRoutedBreadcrumbs = styled(RoutedBreadcrumbs)`
  box-sizing: border-box;
  align-items: center;
  color: #fff;
  min-width: 33%;
  padding-left: 3%;
  .breadcrumbs {
    display: flex;
  }
  .breadcrumbs-item {
    vertical-align: middle;
    font-weight: 700; 
    min-width: 44px;
    min-height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .first a{
    width: 44px;
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .text {
    font-size: 14px;
  }
  .texto > .first {
    color: #fff;
    line-height: 1.3;
    font-size: 30px;
  }

  .texto > .first-historico {
    color: #fff;
    line-height: 1.3;
    font-size: 12px;
    font-weight: 100;
  }

  .texto > .last {
    color: #fff;
    line-height: 1.3;
    font-size: 14px;
  }

  .breadcrumbs-separator {
    font-size: 16px;
    display: inline-block;
    vertical-align: sub;
    line-height: 0;
  }
`;

const SBuscador = styled(Buscador)`
  margin-left: auto;
  align-self: flex-end;
  height: 44px;
  flex: 0 2 300px;
  margin-right: 5%;
  min-width: 28%;  
`;

const SBuscadorMobile = styled(BuscadorMobile)`
  margin-left: auto;
  align-self: flex-end;
  height: 100%;
  flex: 0 0 50px;
  background-color: white;
`;

const StyledA = styled.button`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background: transparent;
  &&.focus-visible {
    outline: 2px solid #222222 !important;
    outline-offset: -2px !important;
  }
`;
